@if (!loading) {
<div class="gt-user-details">

  <h4 class="user-display-name">{{ user.display_name }}</h4>

  <div class="user-top-row">
    <div class="avatar-col">
      <div class="avatar-circle">
        <span class="avatar-initials">{{ avatarInitials }}</span>
      </div>
      <button class="btn btn-info btn-sm" type="button" (click)="deleteImage()">Delete Image</button>
    </div>

    <div class="fields-col">
      <table class="table table-condensed fields-table">
        <tr>
          <td class="lbl">Title</td>
          <td class="val">{{ user.title }} {{ user.business }}</td>
        </tr>
        <tr>
          <td class="lbl">Total Login</td>
          <td class="val">{{ user.login_total }}</td>
        </tr>
        <tr>
          <td class="lbl">Last Login</td>
          <td class="val">{{ user.last_login }}</td>
        </tr>
        <tr>
          <td class="lbl">User Type</td>
          <td class="val">
            <select class="form-control input-sm" [(ngModel)]="selectedUserType"
                    [compareWith]="compareByValue"
                    (ngModelChange)="onUserTypeChange()">
              @for (t of user_types; track $index) {
<option [ngValue]="t">{{ t.label }}</option>
}
            </select>
          </td>
        </tr>
        <tr>
          <td class="lbl">SSO ID</td>
          <td class="val">{{ user.sso_id }}</td>
        </tr>
      </table>
    </div>

    <div class="fields-col">
      <table class="table table-condensed fields-table">
        <tr>
          <td class="lbl">Location</td>
          <td class="val">{{ user.city }} - {{ user.state }} - {{ user.country_code }}</td>
        </tr>
        <tr>
          <td class="lbl">Email</td>
          <td class="val">
            <a href="mailto:{{ user.email }}?Subject=GTW:" target="_top">{{ user.email }}</a>
          </td>
        </tr>
        <tr>
          <td class="lbl">Phone</td>
          <td class="val">{{ user.phone }}</td>
        </tr>
        <tr>
          <td class="lbl">Roles</td>
          <td class="val">
            <select class="form-control input-sm" [(ngModel)]="selectedRoleType"
                    [compareWith]="compareByValue"
                    (ngModelChange)="onRoleTypeChange()">
              @for (r of role_types; track $index) {
<option [ngValue]="r">{{ r.label }}</option>
}
            </select>
          </td>
        </tr>
        <tr>
          <td class="lbl">Account Active</td>
          <td class="val">
            <ap-checkbox [(ngModel)]="active" (onChange)="onActiveChange($event)"></ap-checkbox>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="panel panel-default" style="margin-bottom: 10px;">
    <div class="panel-heading"><strong>Clients:</strong></div>
    <div class="panel-body" style="padding: 2px;">
      <table class="gt-client table table-bordered table-striped table-condensed" style="margin-bottom: 0;">
        <thead>
          <tr>
            <th style="text-align: center;">Client</th>
            <th style="text-align: center;">User Type</th>
            <th style="text-align: center;">Active</th>
            <th style="text-align: center;">Last Updated By</th>
            <th style="text-align: center;">Last Updated On</th>
            <th style="text-align: center;">Expiry Date</th>
          </tr>
        </thead>
        <tbody>
          @for (item of clientList; track $index) {
<tr
              [ngClass]="{'active-client': item.active == 1 && item.user_type_key !== null}">
            <td>{{ item.client_name }}</td>
            <td align="center">
              <select class="form-control input-sm" [(ngModel)]="item.user_type_key"
                      (ngModelChange)="changeClient(item)">
                <option [ngValue]="null"></option>
                @for (ctype of client_user_types; track $index) {
<option [ngValue]="ctype.value">{{ ctype.label }}</option>
}
              </select>
            </td>
            <td align="center">
              <ap-checkbox [ngModel]="item.active == 1"
                           (onChange)="onClientActiveChange($event, item)">
              </ap-checkbox>
            </td>
            <td align="center">{{ item.updated_by }}</td>
            <td align="center">{{ item.updated_on }}</td>
            <td align="center">{{ item.expired_on }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>

</div>
} @else {

  <div style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
    <ap-loading [size]="'24px'" [colorName]="'a-primary'"></ap-loading>
  </div>

}


